import { render } from "./Transporteurs.vue?vue&type=template&id=8f57eae2&scoped=true"
import script from "./Transporteurs.vue?vue&type=script&lang=js"
export * from "./Transporteurs.vue?vue&type=script&lang=js"

import "./Transporteurs.vue?vue&type=style&index=0&id=8f57eae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f57eae2"]])

export default __exports__